import { AxiosError } from "axios";
import ErrorScreen from "../../../../common/components/organisme/ErrorScreen/ErrorScreen";
import useErrorHandler from "../../hooks/useErrorHandler";
import { IS_MODE_PROD } from "../../../../config/config";


export default function ErrorScreenApp({axiosError, message, title}:{axiosError?: AxiosError, message?:string, title?:string}) {
  const {handleErrorAxios} = useErrorHandler();

  if (axiosError){
    handleErrorAxios(axiosError)
  }

  return  <ErrorScreen axiosError={axiosError} title={title} description={message ||(IS_MODE_PROD ? "Veuillez réessayer ultérieurement" : undefined)}/>;
}
